import { createSlice } from "@reduxjs/toolkit";

const langaugeSlice = createSlice({
  name: "languageStore",
  initialState: {
    active: "en-US",
    languages: [
      { name: "English", value: "en-US" },
      { name: "Indonesia", value: "id-ID" },
      { name: "Japan", value: "jp-JP" },
    ],
    translations: {
      SA_NUMBER_TXT: {
        "id-ID": "",
        "en-US": "SA Number",
        "jp-JP": "",
      },
      AGREEMENT_TXT: {
        "id-ID": "",
        "en-US": "Agreement Signed",
        "jp-JP": "",
      },
      AGREEMENT_DOC_TXT: {
        "id-ID": "",
        "en-US": "Agreement Doc",
        "jp-JP": "",
      },
      REASON_TXT: {
        "id-ID": "",
        "en-US": "Reason",
        "jp-JP": "",
      },
      PDF_CLICK_FULL_TXT: {
        "id-ID": "",
        "en-US": "Click to view full page",
        "jp-JP": "",
      },
      SEND_TXT: {
        "id-ID": "",
        "en-US": "Send",
        "jp-JP": "",
      },
      CONFIM_PASSWORD_CHANGE_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "This changes cannot be undone, please check the field before you submit this action.",
        "jp-JP": "",
      },
      CONFIM_PASSWORD_CHANGE_TXT: {
        "id-ID": "",
        "en-US": "Are you sure you want to change ?",
        "jp-JP": "",
      },
      FIRST_CHANGE_PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "You must change password and email first",
        "jp-JP": "",
      },
      CONFIRM_DELETE_ACCOUNT_TXT: {
        "id-ID": "",
        "en-US": "Yes, delete account",
        "jp-JP": "",
      },
      KYC_GENERIC_REQURIED_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Required",
        "jp-JP": "",
      },
      Logout: {
        "id-ID": "",
        "en-US": "Logout",
        "jp-JP": "",
      },
      "SIGN IN": {
        "id-ID": "",
        "en-US": "SIGN IN",
        "jp-JP": "",
      },
      "Sign In": {
        "id-ID": "",
        "en-US": "Sign In",
        "jp-JP": "",
      },
      LATEST_TRANSACTION_TXT: {
        "id-ID": "",
        "en-US": "Latest Transaction",
        "jp-JP": "",
      },
      DISBURSE_AMOUNT_TXT: {
        "id-ID": "",
        "en-US": "Disbursement Amount",
        "jp-JP": "",
      },
      ACTION_TXT: {
        "id-ID": "",
        "en-US": "Action",
        "jp-JP": "",
      },
      LANGUAGE_TXT: {
        "id-ID": "",
        "en-US": "Language",
        "jp-JP": "",
      },
      SIGN_IN_TXT: {
        "id-ID": "",
        "en-US": "Sign In",
        "jp-JP": "",
      },
      PHONE_NUMBER_TXT: {
        "id-ID": "Nomor HP",
        "en-US": "Phone Number",
        "jp-JP": "電話番号",
      },
      EMP_ID_TXT: {
        "id-ID": "",
        "en-US": "Employee Code or Username",
        "jp-JP": "",
      },
      PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "Password",
        "jp-JP": "",
      },
      PHONE_NUMBER_CAPTION_TXT: {
        "id-ID": "Nomor HP Anda",
        "en-US": "Your Phone Number",
        "jp-JP": "あなたの電話番号",
      },
      EMPLOYEE_ID_CAPTION_TXT: {
        "id-ID": "Contoh: 1238839",
        "en-US": "Example: 1238839",
        "jp-JP": "例: 1238839",
      },
      PASSWORD_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Enter Your Password",
        "jp-JP": "",
      },
      FORGOT_PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "Forgot Password?",
        "jp-JP": "",
      },
      PHONE_NUMBER_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Phone Number is Required !",
        "jp-JP": "",
      },
      EMPLOYEE_ID_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Employee Identity Number is Required !",
        "jp-JP": "",
      },
      PASSWORD_MIN_LENGTH_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Password must have at least 8 characters",
        "jp-JP": "",
      },
      FORGOT_PASSWORD_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Forgot Password",
        "jp-JP": "",
      },
      RESET_PASSWORD_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Reset Password",
        "jp-JP": "",
      },
      BACK_SIGN_IN_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Back to Sign in",
        "jp-JP": "",
      },
      RESET_PASSWORD_CHECK_EMAIL_TXT: {
        "id-ID": "",
        "en-US": "Please check your email to reset your password",
        "jp-JP": "",
      },
      WELCOME_BACK_TXT: {
        "id-ID": "",
        "en-US": "Hello",
        "jp-JP": "",
      },
      HEADER_SA_AMOUNT_TXT: {
        "id-ID": "",
        "en-US": "Your Salary Advance Amount",
        "jp-JP": "",
      },
      SA_REQUEST_AMOUNT_TXT: {
        "id-ID": "",
        "en-US": "Request Amount",
        "jp-JP": "",
      },
      SA_REQUEST_AMOUNT_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "e.g 4,000,000",
        "jp-JP": "",
      },
      SA_TOTAL_FEE_TXT: {
        "id-ID": "",
        "en-US": "Total Fee",
        "jp-JP": "",
      },
      SA_RECEIVE_ACC_TXT: {
        "id-ID": "",
        "en-US": "Receiving Account",
        "jp-JP": "",
      },
      SELECT_BANK_ACC_TXT: {
        "id-ID": "",
        "en-US": "Select Account",
        "jp-JP": "",
      },
      SA_REQUEST_TXT: {
        "id-ID": "",
        "en-US": "Request",
        "jp-JP": "",
      },
      SA_REQUEST_B2C_TXT: {
        "id-ID": "",
        "en-US": "Request Salary Advance",
        "jp-JP": "",
      },
      B2C_TITLE_TXT: {
        "id-ID": "",
        "en-US": "Salary Advance",
        "jp-JP": "",
      },
      DFA_INSURANCE_ICO_TXT: {
        "id-ID": "",
        "en-US": "Insurance",
        "jp-JP": "",
      },
      DFA_INVEST_ICO_TXT: {
        "id-ID": "",
        "en-US": "Investment",
        "jp-JP": "",
      },
      DFA_LOAN_ICO_TXT: {
        "id-ID": "",
        "en-US": "Loan",
        "jp-JP": "",
      },
      DFA_OTHERS_ICO_TXT: {
        "id-ID": "",
        "en-US": "Others",
        "jp-JP": "",
      },
      MENU_HOME_ICO_TXT: {
        "id-ID": "",
        "en-US": "Home",
        "jp-JP": "",
      },
      MENU_HOME_TRX_TXT: {
        "id-ID": "",
        "en-US": "Transaction",
        "jp-JP": "",
      },
      MENU_HOME_ACC_TXT: {
        "id-ID": "",
        "en-US": "Account",
        "jp-JP": "",
      },
      MENU_HOME_PROFILE_TXT: {
        "id-ID": "",
        "en-US": "Profile",
        "jp-JP": "",
      },
      TRX_STATUS_FAILED_TXT: {
        "id-ID": "",
        "en-US": "Failed",
        "jp-JP": "",
      },
      TRX_STATUS_PROCESS_TXT: {
        "id-ID": "",
        "en-US": "In Process",
        "jp-JP": "",
      },
      TRX_STATUS_DELIVERED_TXT: {
        "id-ID": "",
        "en-US": "Delivered",
        "jp-JP": "",
      },
      TRX_HISTORY_TTL_TXT: {
        "id-ID": "",
        "en-US": "Transaction History",
        "jp-JP": "",
      },
      TRX_STATUS_DESC_ONG_VERIFY_TXT: {
        "id-ID": "",
        "en-US": "Ongoing Verification Process",
        "jp-JP": "",
      },
      TRX_STATUS_DESC_ONG_DISBURSE_TXT: {
        "id-ID": "",
        "en-US": "Ongoing Disbursement Process",
        "jp-JP": "",
      },
      TRX_STATUS_DESC_REJECTED_TXT: {
        "id-ID": "",
        "en-US": "Rejected",
        "jp-JP": "",
      },
      TRX_STATUS_DESC_FAILED_DISBURSE_TXT: {
        "id-ID": "",
        "en-US": "Disbursement Failure. Please Check Destination Account",
        "jp-JP": "",
      },
      TRX_STATUS_DESC_COMPLETE_TXT: {
        "id-ID": "",
        "en-US": "Transaction is Complete",
        "jp-JP": "",
      },
      TRX_DETAIL_TTL_TXT: {
        "id-ID": "",
        "en-US": "Detail Transaction",
        "jp-JP": "",
      },
      TRX_DETAIL_REQUEST_DATE: {
        "id-ID": "",
        "en-US": "Request Date",
        "jp-JP": "",
      },
      STATUS_TXT: {
        "id-ID": "",
        "en-US": "Status",
        "jp-JP": "",
      },
      DESC_TXT: {
        "id-ID": "Keterangan",
        "en-US": "Description",
        "jp-JP": "説明",
      },
      DESC_CAPTION_TXT: {
        "id-ID": "Deskripsi Anda",
        "en-US": "Your Description",
        "jp-JP": "あなたの説明",
      },
      SA_TRANSFER_FEE_TXT: {
        "id-ID": "",
        "en-US": "Transfer Charge",
        "jp-JP": "",
      },
      SA_MEMBERSHIP_FEE_TXT: {
        "id-ID": "",
        "en-US": "Membership Fee",
        "jp-JP": "",
      },
      SA_REGISTRATION_FEE_TXT: {
        "id-ID": "",
        "en-US": "Registration Fee",
        "jp-JP": "",
      },
      SA_SYSTEM_USAGE_FEE_TXT: {
        "id-ID": "",
        "en-US": "System Usage App",
        "jp-JP": "",
      },
      SA_TOTAL_RECEIVE_TXT: {
        "id-ID": "",
        "en-US": "Total Receiving",
        "jp-JP": "",
      },
      DISBURSE_ACC_TTL_TXT: {
        "id-ID": "",
        "en-US": "Account",
        "jp-JP": "",
      },
      DISBURSE_ADD_ACC_TTL_TXT: {
        "id-ID": "",
        "en-US": "Add New Account",
        "jp-JP": "",
      },
      SAVE_TXT: {
        "id-ID": "",
        "en-US": "Save",
        "jp-JP": "",
      },
      DISBURSE_ACC_TYPE_TXT: {
        "id-ID": "",
        "en-US": "Type",
        "jp-JP": "",
      },
      DISBURSE_ACC_TYPE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Type",
        "jp-JP": "",
      },
      DISBURSE_ACC_TYPE_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Account Type is Required!",
        "jp-JP": "",
      },
      DISBURSE_ACTIVE_BANK_TXT: {
        "id-ID": "",
        "en-US": "Your Account",
        "jp-JP": "",
      },
      DISBURSE_ACC_BANK_MANAGE_TXT: {
        "id-ID": "",
        "en-US": "Manage Your Account",
        "jp-JP": "",
      },
      DISBURSE_ACC_BANK_TXT: {
        "id-ID": "",
        "en-US": "Account",
        "jp-JP": "",
      },
      DISBURSE_ACC_BANK_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Your Account",
        "jp-JP": "",
      },
      DISBURSE_ACC_NUMBER_TXT: {
        "id-ID": "",
        "en-US": "Account Number",
        "jp-JP": "",
      },
      DELETE_TXT: {
        "id-ID": "",
        "en-US": "Delete",
        "jp-JP": "",
      },
      DISBURSE_ACC_NAME_TXT: {
        "id-ID": "",
        "en-US": "Account Name",
        "jp-JP": "",
      },
      DISBURSE_ACC_NAME_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Account Name",
        "jp-JP": "",
      },
      DISBURSE_ACC_NAME_ID_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Account Name is Required!",
        "jp-JP": "",
      },
      DISBURSE_ACC_NUMBER_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Account Number",
        "jp-JP": "",
      },
      DISBURSE_ACC_NUMBER_ID_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Account Number is Required!",
        "jp-JP": "",
      },
      PROFILE_TTL_TXT: {
        "id-ID": "",
        "en-US": "Profile",
        "jp-JP": "",
      },
      FULL_NAME_TXT: {
        "id-ID": "Nama Lengkap",
        "en-US": "Full Name",
        "jp-JP": "フルネーム",
      },
      FULL_NAME_CAPTION_TXT: {
        "id-ID": "Nama Lengkap Anda",
        "en-US": "Your Full Name",
        "jp-JP": "氏名",
      },
      COMPANY_TXT: {
        "id-ID": "Perusahaan",
        "en-US": "Company",
        "jp-JP": "会社",
      },
      COMPANY_CAPTION_TXT: {
        "id-ID": "Nama Perusahaan Anda",
        "en-US": "Your Company Name",
        "jp-JP": "会社名",
      },
      CHANGE_PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "Change Password",
        "jp-JP": "",
      },
      USER_MANUAL_TXT: {
        "id-ID": "",
        "en-US": "User Manual",
        "jp-JP": "",
      },
      FAQ_TXT: {
        "id-ID": "",
        "en-US": "FAQ",
        "jp-JP": "",
      },
      CONTACT_US_TXT: {
        "id-ID": "",
        "en-US": "Contact Us",
        "jp-JP": "",
      },
      SIGN_OUT_TXT: {
        "id-ID": "",
        "en-US": "Sign Out",
        "jp-JP": "",
      },
      CURRENT_PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "Current Password",
        "jp-JP": "",
      },
      CURRENT_PASSWORD_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Current Password",
        "jp-JP": "",
      },
      NEW_PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "New Password",
        "jp-JP": "",
      },
      NEW_PASSWORD_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your New Password",
        "jp-JP": "",
      },
      CONFIRM_PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "Confirm New Password",
        "jp-JP": "",
      },
      CONFIRM_PASSWORD_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Enter Your Password",
        "jp-JP": "",
      },
      PASSWORD_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Password is Required !",
        "jp-JP": "",
      },
      SA_CONFIRM_REQUEST_TTL_TXT: {
        "id-ID": "",
        "en-US": "Confirmation Request",
        "jp-JP": "",
      },
      SA_CONFIRM_PASSWORD_TTL_TXT: {
        "id-ID": "",
        "en-US": "Confirmation Password",
        "jp-JP": "",
      },
      SA_CONFIRM_DETAIL_TTL_TXT: {
        "id-ID": "",
        "en-US": "Detail Request",
        "jp-JP": "",
      },
      RECEIVING_TXT: {
        "id-ID": "",
        "en-US": "Receiving",
        "jp-JP": "",
      },
      TNC_TTL_TXT: {
        "id-ID": "",
        "en-US": "Terms and Conditions",
        "jp-JP": "",
      },
      AGREE_TNC_TXT: {
        "id-ID": "",
        "en-US": "I agree with this terms and conditions",
        "jp-JP": "",
      },
      AGREE_TNC_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "You must agree before proceeding",
        "jp-JP": "",
      },
      AGREE_02_TNC_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "You must agree to the terms and conditions",
        "jp-JP": "",
      },
      NEW_CONFIRM_PASSWORD_TXT: {
        "id-ID": "",
        "en-US": "Confirmation Password",
        "jp-JP": "",
      },
      ENTER_PASSWORD_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Enter Your Password",
        "jp-JP": "",
      },
      SUBMIT_TXT: {
        "id-ID": "Kirim",
        "en-US": "Submit",
        "jp-JP": "提出する",
      },
      REQUEST_SUCCESSFULL_TXT: {
        "id-ID": "",
        "en-US": "Confirmation Success",
        "jp-JP": "",
      },
      REQUEST_SUCCESSFULL_DESC_TXT: {
        "id-ID": "",
        "en-US": "Your request has been successfully submitted",
        "jp-JP": "",
      },
      OK_TXT: {
        "id-ID": "",
        "en-US": "OK",
        "jp-JP": "",
      },
      SET_PASSWORD_EMAIL_TTL_TXT: {
        "id-ID": "",
        "en-US": "Set Password & Email",
        "jp-JP": "",
      },
      SET_PASSWORD_EMAIL_DESC_TXT: {
        "id-ID": "",
        "en-US": "Please complete your details to continue",
        "jp-JP": "",
      },
      EMAIL_TXT: {
        "id-ID": "Alamat Email",
        "en-US": "Email Address",
        "jp-JP": "電子メールアドレス",
      },
      EMAIL_CAPTION_TXT: {
        "id-ID": "Alamat email Anda",
        "en-US": "Your email address",
        "jp-JP": "あなたのメールアドレス",
      },
      SUCCESS_TXT: {
        "id-ID": "Berhasil",
        "en-US": "Success",
        "jp-JP": "成功する",
      },
      SET_PASSWORD_EMAIL_SUCCESS_DESC_TXT: {
        "id-ID": "",
        "en-US":
          "Your password has been changed successfully and Please check your email for email confirmation",
        "jp-JP": "",
      },
      LOGIN_TXT: {
        "id-ID": "",
        "en-US": "Login",
        "jp-JP": "",
      },
      UPLOAD_PHOTO_TTL_TXT: {
        "id-ID": "",
        "en-US": "Registration",
        "jp-JP": "",
      },
      UPLOAD_PHOTO_HEADING_TXT: {
        "id-ID": "",
        "en-US": "Proof of Identity",
        "jp-JP": "",
      },
      UPLOAD_PHOTO_DESC_TXT: {
        "id-ID": "",
        "en-US":
          "In order to completed your registration. Please upload a copy of your identity with a clear selfie photo to proof the document holder",
        "jp-JP": "",
      },
      UPLOAD_PHOTO_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Upload Proof of Identity",
        "jp-JP": "",
      },
      UPLOAD_SELFIE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Upload Selfie with Identity",
        "jp-JP": "",
      },
      PICK_PHOTO: {
        "id-ID": "",
        "en-US": "Choose File",
        "jp-JP": "",
      },
      TAKE_PHOTO_TXT: {
        "id-ID": "",
        "en-US": "Take a photo",
        "jp-JP": "",
      },
      TAKE_SELFIE_TXT: {
        "id-ID": "",
        "en-US": "Take a selfie",
        "jp-JP": "",
      },
      CONFIRM_TXT: {
        "id-ID": "",
        "en-US": "Confirm",
        "jp-JP": "",
      },
      UPLOAD_PHOTO_ID_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Upload a Proof Identity is Required !",
        "jp-JP": "",
      },
      UPLOAD_SELFIE_ID_EMPTY_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Upload a Selfie With Identity is Required !",
        "jp-JP": "",
      },
      UPLOAD_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Required !",
        "jp-JP": "",
      },
      KYC_TTL_TXT: {
        "id-ID": "",
        "en-US": "Registration",
        "jp-JP": "",
      },
      PERSONAL_TXT: {
        "id-ID": "",
        "en-US": "Personal",
        "jp-JP": "",
      },
      EMERGENCY_TXT: {
        "id-ID": "",
        "en-US": "Emergency",
        "jp-JP": "",
      },
      ADDRESS_TXT: {
        "id-ID": "",
        "en-US": "Address",
        "jp-JP": "",
      },
      KYC_ADDRESS_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Address is Required !",
        "jp-JP": "",
      },
      WORK_INFO_TXT: {
        "id-ID": "",
        "en-US": "Work Info",
        "jp-JP": "",
      },
      KYC_NAME_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Full Name",
        "jp-JP": "",
      },
      KYC_NAME_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Full Name Required !",
        "jp-JP": "",
      },
      ID_NUMBER_TXT: {
        "id-ID": "",
        "en-US": "Identity Number",
        "jp-JP": "",
      },
      KYC_ID_NUMBER_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Identity Number",
        "jp-JP": "",
      },
      KYC_ID_NUMBER_ERROR_TTL_TXT_01: {
        "id-ID": "",
        "en-US": "Identity Number is Required !",
        "jp-JP": "",
      },
      KYC_ID_NUMBER_ERROR_TTL_TXT_02: {
        "id-ID": "",
        "en-US": "Identity Number must have 16 digits !",
        "jp-JP": "",
      },
      KYC_EMAIL_ERROR_TTL_TXT_01: {
        "id-ID": "",
        "en-US": "Email Address is Required !",
        "jp-JP": "",
      },
      KYC_EMAIL_ERROR_TTL_TXT_02: {
        "id-ID": "",
        "en-US": "That doesn't look like an email address",
        "jp-JP": "",
      },
      KYC_PHONE_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Phone Number is Required !",
        "jp-JP": "",
      },
      DOB_TXT: {
        "id-ID": "",
        "en-US": "Date of Birth",
        "jp-JP": "",
      },
      KYC_DOB_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Date of Birth",
        "jp-JP": "",
      },
      KYC_DOB_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Date of Birth is  !",
        "jp-JP": "",
      },
      BIRTHPLACE_TXT: {
        "id-ID": "",
        "en-US": "Place of Birth",
        "jp-JP": "",
      },
      KYC_BIRTHPLACE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "e.g Jakarta",
        "jp-JP": "",
      },
      GENDER_TXT: {
        "id-ID": "",
        "en-US": "Gender",
        "jp-JP": "",
      },
      GENDER_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Gender",
        "jp-JP": "",
      },
      GENDER_MALE_TXT: {
        "id-ID": "",
        "en-US": "MALE",
        "jp-JP": "",
      },
      GENDER_FEMALE_TXT: {
        "id-ID": "",
        "en-US": "FEMALE",
        "jp-JP": "",
      },
      KYC_GENDER_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Gender is Required !",
        "jp-JP": "",
      },
      RELIGION_TXT: {
        "id-ID": "",
        "en-US": "Religion",
        "jp-JP": "",
      },
      KYC_RELIGION_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Religion is Required !",
        "jp-JP": "",
      },
      RELIGION_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Religion",
        "jp-JP": "",
      },
      RELIGION_01_TXT: {
        "id-ID": "",
        "en-US": "MOSLEM",
        "jp-JP": "",
      },
      RELIGION_02_TXT: {
        "id-ID": "",
        "en-US": "CHRISTIAN",
        "jp-JP": "",
      },
      RELIGION_03_TXT: {
        "id-ID": "",
        "en-US": "CATHOLIC",
        "jp-JP": "",
      },
      RELIGION_04_TXT: {
        "id-ID": "",
        "en-US": "HINDU",
        "jp-JP": "",
      },
      RELIGION_05_TXT: {
        "id-ID": "",
        "en-US": "BUDHA",
        "jp-JP": "",
      },
      RELIGION_06_TXT: {
        "id-ID": "",
        "en-US": "CONFUSIUS",
        "jp-JP": "",
      },
      RELIGION_07_TXT: {
        "id-ID": "",
        "en-US": "OTHERS",
        "jp-JP": "",
      },
      MARITAL_TXT: {
        "id-ID": "",
        "en-US": "Marital Status",
        "jp-JP": "",
      },
      MARITAL_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Marital Status",
        "jp-JP": "",
      },
      KYC_MARITAL_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Marital Status is Required !",
        "jp-JP": "",
      },
      MARITALSTATUS_01_TXT: {
        "id-ID": "",
        "en-US": "SINGLE",
        "jp-JP": "",
      },
      MARITALSTATUS_02_TXT: {
        "id-ID": "",
        "en-US": "MARRIED",
        "jp-JP": "",
      },
      MARITALSTATUS_03_TXT: {
        "id-ID": "",
        "en-US": "DIVORCED",
        "jp-JP": "",
      },
      MARITALSTATUS_04_TXT: {
        "id-ID": "",
        "en-US": "WIDOWED",
        "jp-JP": "",
      },
      MARITALSTATUS_05_TXT: {
        "id-ID": "",
        "en-US": "OTHERS",
        "jp-JP": "",
      },
      PRIMARY_CONTACT_TXT: {
        "id-ID": "",
        "en-US": "Primary Contact",
        "jp-JP": "",
      },
      SECONDARY_CONTACT_TXT: {
        "id-ID": "",
        "en-US": "Secondary Contact",
        "jp-JP": "",
      },
      RELATIONSHIP_TXT: {
        "id-ID": "",
        "en-US": "Relationship",
        "jp-JP": "",
      },
      RELATIONSHIP_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Relationship",
        "jp-JP": "",
      },
      RELATIONSHIP_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Relationship is Required !",
        "jp-JP": "",
      },
      RELATIONSHIP_01_TXT: {
        "id-ID": "",
        "en-US": "SPOUSE",
        "jp-JP": "",
      },
      RELATIONSHIP_02_TXT: {
        "id-ID": "",
        "en-US": "PARENTS",
        "jp-JP": "",
      },
      RELATIONSHIP_03_TXT: {
        "id-ID": "",
        "en-US": "CHILDREN",
        "jp-JP": "",
      },
      RELATIONSHIP_04_TXT: {
        "id-ID": "",
        "en-US": "BROTHER/SISTER",
        "jp-JP": "",
      },
      RELATIONSHIP_05_TXT: {
        "id-ID": "",
        "en-US": "SIBLINGS",
        "jp-JP": "",
      },
      RELATIONSHIP_06_TXT: {
        "id-ID": "",
        "en-US": "FRIENDS",
        "jp-JP": "",
      },
      RELATIONSHIP_07_TXT: {
        "id-ID": "",
        "en-US": "COLLEAGUES",
        "jp-JP": "",
      },
      RELATIONSHIP_08_TXT: {
        "id-ID": "",
        "en-US": "OTHERS",
        "jp-JP": "",
      },
      RESIDENT_STATUS_TXT: {
        "id-ID": "",
        "en-US": "Residential Status",
        "jp-JP": "",
      },
      RESIDENT_STATUS_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Residential Status",
        "jp-JP": "",
      },
      RESIDENT_STATUS_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Residential Status is Required !",
        "jp-JP": "",
      },
      RESIDENTSTATUS_01_TXT: {
        "id-ID": "",
        "en-US": "OWN",
        "jp-JP": "",
      },
      RESIDENTSTATUS_02_TXT: {
        "id-ID": "",
        "en-US": "RENT",
        "jp-JP": "",
      },
      RESIDENTSTATUS_03_TXT: {
        "id-ID": "",
        "en-US": "SHORT_RENT",
        "jp-JP": "",
      },
      RESIDENTSTATUS_04_TXT: {
        "id-ID": "",
        "en-US": "FAMILY",
        "jp-JP": "",
      },
      RESIDENTSTATUS_05_TXT: {
        "id-ID": "",
        "en-US": "MORTGAGE",
        "jp-JP": "",
      },
      RESIDENTSTATUS_06_TXT: {
        "id-ID": "",
        "en-US": "COMPANY",
        "jp-JP": "",
      },
      RESIDENTSTATUS_07_TXT: {
        "id-ID": "",
        "en-US": "OTHERS",
        "jp-JP": "",
      },
      ADDRESS_HOME_TXT: {
        "id-ID": "",
        "en-US": "Address",
        "jp-JP": "",
      },
      ADDRESS_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Address",
        "jp-JP": "",
      },
      PROVINCE_TXT: {
        "id-ID": "",
        "en-US": "Province",
        "jp-JP": "",
      },
      PROVINCE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Your Province",
        "jp-JP": "",
      },
      PROVINCE_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Province is Required !",
        "jp-JP": "",
      },
      CITY_TXT: {
        "id-ID": "",
        "en-US": "City",
        "jp-JP": "",
      },
      CITY_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your City",
        "jp-JP": "",
      },
      CITY_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Kota Diperlukan !",
        "jp-JP": "",
      },
      DISTRICT_TXT: {
        "id-ID": "",
        "en-US": "District",
        "jp-JP": "",
      },
      DISTRICT_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your District",
        "jp-JP": "",
      },
      DISTRICT_ERROR_TXT: {
        "id-ID": "",
        "en-US": "District Required !",
        "jp-JP": "",
      },
      VILLAGE_TXT: {
        "id-ID": "",
        "en-US": "Village",
        "jp-JP": "",
      },
      VILLAGE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Village",
        "jp-JP": "",
      },
      VILLAGE_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Village is Required !",
        "jp-JP": "",
      },
      POSTCODE_TXT: {
        "id-ID": "",
        "en-US": "Postal Code",
        "jp-JP": "",
      },
      POSTCODE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Postal Code",
        "jp-JP": "",
      },
      POSTCODE_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Postal Code is Required !",
        "jp-JP": "",
      },
      POSTCODE_NUMBER_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Postal Code maximum 7 digits !",
        "jp-JP": "",
      },
      RT_TXT: {
        "id-ID": "",
        "en-US": "Block",
        "jp-JP": "",
      },
      RT_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Block",
        "jp-JP": "",
      },
      RT_ERROR_TXT: {
        "id-ID": "",
        "en-US": "RT is Required !",
        "jp-JP": "",
      },
      RW_TXT: {
        "id-ID": "",
        "en-US": "Number",
        "jp-JP": "",
      },
      RW_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Number",
        "jp-JP": "",
      },
      RW_ERROR_TXT: {
        "id-ID": "",
        "en-US": "RW Required !",
        "jp-JP": "",
      },
      HOME_PHONE_NUMBER_TXT: {
        "id-ID": "",
        "en-US": "Home Phone Number",
        "jp-JP": "",
      },
      HOME_PHONE_NUMBER_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Home Phone Number",
        "jp-JP": "",
      },
      HOME_PHONE_NUMBER_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Home Phone Number is Required !",
        "jp-JP": "",
      },
      LAST_EDUCATION_TXT: {
        "id-ID": "",
        "en-US": "Last Education Level",
        "jp-JP": "",
      },
      LAST_EDUCATION_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Education",
        "jp-JP": "",
      },
      LAST_EDUCATION_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Last Education Level Required !",
        "jp-JP": "",
      },
      EDUCATION_01_TXT: {
        "id-ID": "",
        "en-US": "NOT ATTENDING SCHOOL",
        "jp-JP": "",
      },
      EDUCATION_02_TXT: {
        "id-ID": "",
        "en-US": "ELEMENTARY SCHOOL",
        "jp-JP": "",
      },
      EDUCATION_03_TXT: {
        "id-ID": "",
        "en-US": "JUNIOR HIGH SCHOOL",
        "jp-JP": "",
      },
      EDUCATION_04_TXT: {
        "id-ID": "",
        "en-US": "SENIOR HIGH SCHOOL",
        "jp-JP": "",
      },
      EDUCATION_05_TXT: {
        "id-ID": "",
        "en-US": "TECHNICAL COLLEGE",
        "jp-JP": "",
      },
      EDUCATION_06_TXT: {
        "id-ID": "",
        "en-US": "DIPLOMA 1",
        "jp-JP": "",
      },
      EDUCATION_07_TXT: {
        "id-ID": "",
        "en-US": "DIPLOMA 2",
        "jp-JP": "",
      },
      EDUCATION_08_TXT: {
        "id-ID": "",
        "en-US": "DIPLOMA 3",
        "jp-JP": "",
      },
      EDUCATION_09_TXT: {
        "id-ID": "",
        "en-US": "BACHELOR DEGREE",
        "jp-JP": "",
      },
      EDUCATION_10_TXT: {
        "id-ID": "",
        "en-US": "MASTER DEGREE",
        "jp-JP": "",
      },
      EDUCATION_11_TXT: {
        "id-ID": "",
        "en-US": "DOCTOR DEGREE",
        "jp-JP": "",
      },
      JOB_TYPE_TXT: {
        "id-ID": "",
        "en-US": "Job Type",
        "jp-JP": "",
      },
      JOB_TYPE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Job Type",
        "jp-JP": "",
      },
      JOB_TYPE_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Job Type is Required !",
        "jp-JP": "",
      },
      JOBTYPE_01_TXT: {
        "id-ID": "",
        "en-US": "Entrepreneur",
        "jp-JP": "",
      },
      JOBTYPE_02_TXT: {
        "id-ID": "",
        "en-US": "Employee(private)",
        "jp-JP": "",
      },
      JOBTYPE_03_TXT: {
        "id-ID": "",
        "en-US": "Employee(public)",
        "jp-JP": "",
      },
      JOBTYPE_04_TXT: {
        "id-ID": "",
        "en-US": "Professional",
        "jp-JP": "",
      },
      JOBTYPE_05_TXT: {
        "id-ID": "",
        "en-US": "Civil",
        "jp-JP": "",
      },
      JOBTYPE_06_TXT: {
        "id-ID": "",
        "en-US": "Student",
        "jp-JP": "",
      },
      JOBTYPE_07_TXT: {
        "id-ID": "",
        "en-US": "Unemployed",
        "jp-JP": "",
      },
      JOBTYPE_08_TXT: {
        "id-ID": "",
        "en-US": "Honorary / Outsourcing employee",
        "jp-JP": "",
      },
      JOB_POSITION_TXT: {
        "id-ID": "",
        "en-US": "Job Position",
        "jp-JP": "",
      },
      JOB_POSITION_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Select Job Position",
        "jp-JP": "",
      },
      JOB_POSITION_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Job Position is Required !",
        "jp-JP": "",
      },
      JOBPOSITION_01_TXT: {
        "id-ID": "",
        "en-US": "Supervisor",
        "jp-JP": "",
      },
      JOBPOSITION_02_TXT: {
        "id-ID": "",
        "en-US": "Director",
        "jp-JP": "",
      },
      JOBPOSITION_03_TXT: {
        "id-ID": "",
        "en-US": "Manager",
        "jp-JP": "",
      },
      JOBPOSITION_04_TXT: {
        "id-ID": "",
        "en-US": "Staff",
        "jp-JP": "",
      },
      JOBPOSITION_05_TXT: {
        "id-ID": "",
        "en-US": "Others",
        "jp-JP": "",
      },
      WORK_SINCE_TXT: {
        "id-ID": "",
        "en-US": "Work Since",
        "jp-JP": "",
      },
      WORK_SINCE_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Work Since",
        "jp-JP": "",
      },
      WORK_SINCE_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Work Since is Required !",
        "jp-JP": "",
      },
      TAX_ID_TXT: {
        "id-ID": "",
        "en-US": "Tax Number",
        "jp-JP": "",
      },
      TAX_ID_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Tax Number",
        "jp-JP": "",
      },
      TAX_ID_ERROR_TXT: {
        "id-ID": "",
        "en-US": "NPWP is Required !",
        "jp-JP": "",
      },
      INCOME_TXT: {
        "id-ID": "",
        "en-US": "Income",
        "jp-JP": "",
      },
      INCOME_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Your Income",
        "jp-JP": "",
      },
      INCOME_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Income is Required !",
        "jp-JP": "",
      },
      JOBINDUSTRY_01_TXT: {
        "id-ID": "",
        "en-US": "Agriculture",
        "jp-JP": "",
      },
      JOBINDUSTRY_02_TXT: {
        "id-ID": "",
        "en-US": "Building",
        "jp-JP": "",
      },
      JOBINDUSTRY_03_TXT: {
        "id-ID": "",
        "en-US": "Communication",
        "jp-JP": "",
      },
      JOBINDUSTRY_04_TXT: {
        "id-ID": "",
        "en-US": "Electricity, gas, and water",
        "jp-JP": "",
      },
      JOBINDUSTRY_05_TXT: {
        "id-ID": "",
        "en-US": "Finance",
        "jp-JP": "",
      },
      JOBINDUSTRY_06_TXT: {
        "id-ID": "",
        "en-US": "Government service",
        "jp-JP": "",
      },
      JOBINDUSTRY_07_TXT: {
        "id-ID": "",
        "en-US": "Indonesia national police",
        "jp-JP": "",
      },
      JOBINDUSTRY_08_TXT: {
        "id-ID": "",
        "en-US": "Lawyer Firm",
        "jp-JP": "",
      },
      JOBINDUSTRY_09_TXT: {
        "id-ID": "",
        "en-US": "Media, Film",
        "jp-JP": "",
      },
      JOBINDUSTRY_10_TXT: {
        "id-ID": "",
        "en-US": "Military",
        "jp-JP": "",
      },
      JOBINDUSTRY_11_TXT: {
        "id-ID": "",
        "en-US": "Mining and excavation",
        "jp-JP": "",
      },
      JOBINDUSTRY_12_TXT: {
        "id-ID": "",
        "en-US": "Oil and gas",
        "jp-JP": "",
      },
      JOBINDUSTRY_13_TXT: {
        "id-ID": "",
        "en-US": "Private services",
        "jp-JP": "",
      },
      JOBINDUSTRY_14_TXT: {
        "id-ID": "",
        "en-US": "Trade, hotel, and restaurant",
        "jp-JP": "",
      },
      JOBINDUSTRY_15_TXT: {
        "id-ID": "",
        "en-US": "Transportation",
        "jp-JP": "",
      },
      JOBINDUSTRY_16_TXT: {
        "id-ID": "",
        "en-US": "Others",
        "jp-JP": "",
      },
      BACK_TXT: {
        "id-ID": "",
        "en-US": "Back",
        "jp-JP": "",
      },
      NEXT_TXT: {
        "id-ID": "",
        "en-US": "Next",
        "jp-JP": "",
      },
      FINISH_TXT: {
        "id-ID": "",
        "en-US": "Finish",
        "jp-JP": "",
      },
      FAQ_01_TXT: {
        "id-ID": "",
        "en-US": "What is SalAd?",
        "jp-JP": "",
      },
      FAQ_01_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "SalAd is your employee benefit financial solution, that allows your employees to decide their own payday in the fastest and most convenient way possible that allows your employees to earn their Salary more seamlessly Anytime, Anywhere & Anyhow!",
        "jp-JP": "",
      },
      FAQ_02_TXT: {
        "id-ID": "",
        "en-US": "How does SalAd work?",
        "jp-JP": "",
      },
      FAQ_02_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "SalAd partners with employers to help the company have a better understanding of their employee’s financial wellness. Once an employer agrees to offer SalAd to their employees as an employee benefit, employees can access their earned but unpaid Salary via the SalAd app.",
        "jp-JP": "",
      },
      FAQ_03_TXT: {
        "id-ID": "",
        "en-US": "Is there any cost for using the SalAd app?",
        "jp-JP": "",
      },
      FAQ_03_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "No, there is no cost at all to set up or give SalAd to your employees.",
        "jp-JP": "",
      },
      FAQ_04_TXT: {
        "id-ID": "",
        "en-US": "How do I return my Salary in Advance?",
        "jp-JP": "",
      },
      FAQ_04_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "Payments will be immediately deducted by system from the Employees’ salary every month.",
        "jp-JP": "",
      },
      FAQ_05_TXT: {
        "id-ID": "",
        "en-US": "Can we apply for a loan from SalAd?",
        "jp-JP": "",
      },
      FAQ_05_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "No. SalAd is not a credit solution. There is no underwriting, no hidden fees, no debt created, and no interest charged.",
        "jp-JP": "",
      },
      FAQ_06_TXT: {
        "id-ID": "",
        "en-US": "How do employees receive their Salary in   Advance?",
        "jp-JP": "",
      },
      FAQ_06_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "Your Salary in Advance will be in your bank account or any payment channel you choose within 2-3minutes.",
        "jp-JP": "",
      },
      FAQ_07_TXT: {
        "id-ID": "",
        "en-US": "How long does it take to implement the SalAd app?",
        "jp-JP": "",
      },
      FAQ_07_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "Our Salary in advance solution could go live within max.48 hours in working days.",
        "jp-JP": "",
      },
      FAQ_08_TXT: {
        "id-ID": "",
        "en-US": "What devices are supported by the SalAd app?",
        "jp-JP": "",
      },
      FAQ_08_CAPTION_TXT: {
        "id-ID": "",
        "en-US":
          "Currently, we are only available to Android users only. iOS is still in development and we’ll be ready soon!",
        "jp-JP": "",
      },
      PDF_SWP_LEFT: {
        "id-ID": "",
        "en-US": "Swipe Left",
        "jp-JP": "",
      },
      PDF_SWP_RIGHT: {
        "id-ID": "",
        "en-US": "Swipe Right",
        "jp-JP": "",
      },
      PDF_ZOOM: {
        "id-ID": "",
        "en-US": "Pinch to Zoom",
        "jp-JP": "",
      },
      KYC_MOTHER_NAME_TTL_TXT: {
        "id-ID": "",
        "en-US": "Mother’s Name",
        "jp-JP": "",
      },
      KYC_MOTHER_NAME_CAPTION_TTL_TXT: {
        "id-ID": "",
        "en-US": "Your Mother’s Name",
        "jp-JP": "",
      },
      KYC_MOTHER_NAME_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Mother’s Name is Required !",
        "jp-JP": "",
      },
      KYC_DEPENDENTS_TTL_TXT: {
        "id-ID": "",
        "en-US": "Dependents",
        "jp-JP": "",
      },
      KYC_DEPENDENTS_CAPTION_TTL_TXT: {
        "id-ID": "",
        "en-US": "Your Dependents",
        "jp-JP": "",
      },
      KYC_DEPENDENTS_ERROR_TTL_TXT: {
        "id-ID": "",
        "en-US": "Your Dependents is Required !",
        "jp-JP": "",
      },
      CONFIRM_PASSWORD_TTL_TXT: {
        "id-ID": "",
        "en-US": "Konfirmasi Password",
        "jp-JP": "",
      },
      CONFIRM_PASSWORD_CAPTION_TTL_TXT: {
        "id-ID": "",
        "en-US": "Konfirmasi Password Anda",
        "jp-JP": "",
      },
      USER_MANUAL_TITLE_01: {
        "id-ID": "",
        "en-US": "Introduction",
        "jp-JP": "",
      },
      USER_MANUAL_TITLE_02: {
        "id-ID": "",
        "en-US": "How employee salary advances work",
        "jp-JP": "",
      },
      USER_MANUAL_TITLE_03: {
        "id-ID": "",
        "en-US": "Timely Salary Advance",
        "jp-JP": "",
      },
      SOON_TTL_TEXT_01: {
        "id-ID": "",
        "en-US": "This Feature Will ",
        "jp-JP": "",
      },
      SOON_TTL_TEXT_02: {
        "id-ID": "",
        "en-US": "Available Soon",
        "jp-JP": "",
      },
      SA_RECEIVE_DETAIL_ACC_TXT: {
        "id-ID": "",
        "en-US": "Receiving Detail",
        "jp-JP": "",
      },
      SET_PASSWORD_SUCCESS_DESC_TXT: {
        "id-ID": "",
        "en-US": "Your password has been changed successfully !",
        "jp-JP": "",
      },
      SET_EMAIL_SUCCESS_DESC_TXT: {
        "id-ID":
          "Silahkan Cek Kembali E-mail Anda Untuk Mengkonfirmasi E-mail Anda",
        "en-US": "Please check your email to confirm your email",
        "jp-JP": "",
      },
      PASSWORD_CHANGED_TXT: {
        "id-ID": "",
        "en-US": "Password Changed",
        "jp-JP": "",
      },
      CANCEL_TXT: {
        "id-ID": "Batal",
        "en-US": "Cancel",
        "jp-JP": "キャンセル",
      },
      CONTINUE_TXT: {
        "id-ID": "",
        "en-US": "Continue",
        "jp-JP": "",
      },
      CONFIRMATION_TXT: {
        "id-ID": "",
        "en-US": "Confirmation",
        "jp-JP": "",
      },
      CONFIRMATION_LOGOUT_TXT: {
        "id-ID": "",
        "en-US": "Are you sure you want to log out?",
        "jp-JP": "",
      },
      AVAILABLE_FEATURE_01_TXT: {
        "id-ID": "",
        "en-US": "This Feature Will be ",
        "jp-JP": "",
      },
      AVAILABLE_FEATURE_02_TXT: {
        "id-ID": "",
        "en-US": "Available Soon",
        "jp-JP": "",
      },
      Failed: {
        "id-ID": "",
        "en-US": "Failed",
        "jp-JP": "",
      },
      "In Process": {
        "id-ID": "",
        "en-US": "In Process",
        "jp-JP": "",
      },
      Delivered: {
        "id-ID": "",
        "en-US": "Delivered",
        "jp-JP": "",
      },
      PASSWORD_MATCH_ERROR_TXT: {
        "id-ID": "",
        "en-US": "The two passwords must match",
        "jp-JP": "",
      },
      CURRENT_PASSWORD_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Current Password is Required !",
        "jp-JP": "",
      },
      NEW_PASSWORD_ERROR_TXT: {
        "id-ID": "",
        "en-US": "New Password is required!",
        "jp-JP": "",
      },
      NEW_PASSWORD_MIN_CHAR_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Passwords must have at least 8 characters!",
        "jp-JP": "",
      },
      NEW_PASSWORD_UPPERCASE_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Passwords must have at least one uppercase character!",
        "jp-JP": "",
      },
      NEW_PASSWORD_LOWERCASE_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Passwords must have at least one lowercase character!",
        "jp-JP": "",
      },
      NEW_PASSWORD_NUMBER_ERROR_TXT: {
        "id-ID": "",
        "en-US": "Passwords must have at least one number!",
        "jp-JP": "",
      },
      NO_INTERNET_TTL_TXT: {
        "id-ID": "",
        "en-US": "No Internet Connection",
        "jp-JP": "",
      },
      NO_INTERNET_CAPTION_TTL_TXT: {
        "id-ID":
          "Silakan periksa koneksi internet Anda, atau hubungkan lagi ke Wi-Fi",
        "en-US": "Please check your connection again, or connect to Wi-Fi",
        "jp-JP": "",
      },
      NO_INTERNET_BTN_HOME: {
        "id-ID": "",
        "en-US": "Back to home screen",
        "jp-JP": "",
      },
      NO_INTERNET_BTN_LOGIN: {
        "id-ID": "",
        "en-US": "Back to login screen",
        "jp-JP": "",
      },
      TAB_LIFE: {
        "id-ID": "",
        "en-US": "Jiwa",
        "jp-JP": "",
      },
      TAB_HEALTH: {
        "id-ID": "",
        "en-US": "Kesehatan",
        "jp-JP": "",
      },
      PRODUCT_BY: {
        "id-ID": "",
        "en-US": "Product by",
        "jp-JP": "",
      },
      START_FROM: {
        "id-ID": "",
        "en-US": "Start from",
        "jp-JP": "",
      },
      PER_MONTH: {
        "id-ID": "",
        "en-US": "/month",
        "jp-JP": "",
      },
      PER_YEAR: {
        "id-ID": "",
        "en-US": "/year",
        "jp-JP": "",
      },
      SEE_BROCHURE: {
        "id-ID": "",
        "en-US": "Summary Info Products & Services",
        "jp-JP": "",
      },
      BENEFIT: {
        "id-ID": "",
        "en-US": "Benefit",
        "jp-JP": "",
      },
      ADDITIONAL_BENEFIT: {
        "id-ID": "",
        "en-US": "Additional Benefit",
        "jp-JP": "",
      },
      INSURANCE_CONFIRM_TXT: {
        "id-ID": "",
        "en-US": "Confirm",
        "jp-JP": "",
      },
      ERROR_REQUIRED_TXT: {
        "id-ID": "",
        "en-US": "Please fill in the information above",
        "jp-JP": "",
      },
      PROTECTION_FOR_TXT: {
        "id-ID": "",
        "en-US": "Protection for",
        "jp-JP": "",
      },
      PROTECTION_FOR_LABEL_TXT: {
        "id-ID": "",
        "en-US": "Insurance membership for",
        "jp-JP": "",
      },
      SELF_TXT: {
        "id-ID": "",
        "en-US": "Self",
        "jp-JP": "",
      },
      MOTHER_TXT: {
        "id-ID": "",
        "en-US": "Mother",
        "jp-JP": "",
      },
      FATHER_TXT: {
        "id-ID": "",
        "en-US": "Father",
        "jp-JP": "",
      },
      WIFE_TXT: {
        "id-ID": "",
        "en-US": "Wife",
        "jp-JP": "",
      },
      HUSBAND_TXT: {
        "id-ID": "",
        "en-US": "Husband",
        "jp-JP": "",
      },
      BROTHER_TXT: {
        "id-ID": "",
        "en-US": "Brother",
        "jp-JP": "",
      },
      SISTER_TXT: {
        "id-ID": "",
        "en-US": "Sister",
        "jp-JP": "",
      },
      SON_TXT: {
        "id-ID": "",
        "en-US": "Son",
        "jp-JP": "",
      },
      DAUGHTER_TXT: {
        "id-ID": "",
        "en-US": "Daughter",
        "jp-JP": "",
      },
      INSURANCE_PLAN_TXT: {
        "id-ID": "",
        "en-US": "PLAN",
        "jp-JP": "",
      },
      INSURANCE_PREMI_COST: {
        "id-ID": "",
        "en-US": "Premi Cost",
        "jp-JP": "",
      },
      SELECT_PLAN: {
        "id-ID": "",
        "en-US": "Pilih Plan",
        "jp-JP": "",
      },
      INSURANCE_PURCHASE_TXT: {
        "id-ID": "",
        "en-US": "Purchase",
        "jp-JP": "",
      },
      ADD_CC_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Are you sure you want to delete this account?",
        "jp-JP": "",
      },
      ADD_CC_CAPTION_SUCCESS_TXT: {
        "id-ID": "",
        "en-US": "Account Removed",
        "jp-JP": "",
      },
      SA_REQUIRED_01_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Request Amount is Required !",
        "jp-JP": "",
      },
      SA_REQUIRED_02_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Request Amount cannot be less than ",
        "jp-JP": "",
      },
      SA_REQUIRED_03_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Request Amount cannot be greater than",
        "jp-JP": "",
      },
      SA_REQUIRED_04_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Request Amount must be multiple by 50,000",
        "jp-JP": "",
      },
      SA_REQUIRED_ACC_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Receiving Account is Required !",
        "jp-JP": "",
      },
      SA_FEE_ERROR_CAPTION_TXT: {
        "id-ID": "",
        "en-US": "Cannot retrieve info fee, please try again",
        "jp-JP": "",
      },
      INSURED_TXT: {
        "id-ID": "",
        "en-US": "Insured",
        "jp-JP": "",
      },
      INSURANCE_PERSONAL_DATA_TXT: {
        "id-ID": "",
        "en-US": "Personal Data",
        "jp-JP": "",
      },
      INSURANCE_POLICYHOLDER_DATA_TXT: {
        "id-ID": "",
        "en-US": "Policyholder Data",
        "jp-JP": "",
      },
      INSURANCE_INSURED_DATA_TXT: {
        "id-ID": "",
        "en-US": "Insured Data",
        "jp-JP": "",
      },
      INSURANCE_TITLE_TXT: {
        "id-ID": "",
        "en-US": "Policy Holder",
        "jp-JP": "",
      },
      FULL_NAME_INSURED_TXT: {
        "id-ID": "",
        "en-US": "Insured Full Name",
        "jp-JP": "",
      },
      FULL_NAME__INSURED_ERROR_TTL_TX: {
        "id-ID": "",
        "en-US": " Full Name Insured is Required !",
        "jp-JP": "",
      },
      ERROR_PAGE_TTL_TXT_01: {
        "id-ID": "",
        "en-US": "Oops Sorry",
        "jp-JP": "",
      },
      ERROR_PAGE_TTL_TXT_02: {
        "id-ID": "",
        "en-US": "Something has gone wrong...",
        "jp-JP": "",
      },
      INSURANCE_PAYMENT_TXT: {
        "id-ID": "",
        "en-US": "Payment",
        "jp-JP": "",
      },
      TAB_DETAIL_01_TLL_TX: {
        "id-ID": "",
        "en-US": "Product Details",
        "jp-JP": "",
      },
      TAB_DETAIL_02_TLL_TX: {
        "id-ID": "",
        "en-US": "FAQ",
        "jp-JP": "",
      },
      REFRESH_TEXT: {
        "id-ID": "",
        "en-US": "Refresh",
        "jp-JP": "",
      },
      SEE_BROCHURE_TTL_TX: {
        "id-ID": "",
        "en-US": "Summary Product & Services",
        "jp-JP": "",
      },
      SUM_ASSURED: {
        "id-ID": "",
        "en-US": "Sum Assured",
        "jp-JP": "",
      },
      MILLION: {
        "id-ID": "",
        "en-US": "Million",
        "jp-JP": "",
      },
      FULL_NAME: {
        "id-ID": "Nama Lengkap",
        "en-US": "Full Name",
        "jp-JP": "フルネーム",
      },
      EMAIL: {
        "id-ID": "",
        "en-US": "Email",
        "jp-JP": "",
      },
      SA_REGULAR_TOPUP_TXT: {
        "id-ID": "",
        "en-US": "Regular Top Up",
        "jp-JP": "",
      },
      SA_DISBURSMENT_DATE_TXT: {
        "id-ID": "",
        "en-US": "Disbursement Date",
        "jp-JP": "",
      },
      SA_REGULAR_ATTENTION_TXT: {
        "id-ID":
          "Tanggal pencairan Anda berikutnya adalah tanggal [DISBURSEMENT_DATE] setiap bulan",
        "en-US":
          "Your next disbursement date is [DISBURSEMENT_DATE] of every month",
        "jp-JP": "",
      },
      SA_TERMS_01_TXT: {
        "id-ID": "",
        "en-US": "Thank you dor using Salary Advance service by salad.",
        "jp-JP": "",
      },
      SA_TERMS_02_TXT: {
        "id-ID": "",
        "en-US":
          "You have chosen Regular top-up Salary Adavance product which will be automaticly requested every month on the",
        "jp-JP": "",
      },
      SA_TERMS_03_TXT: {
        "id-ID": "",
        "en-US":
          "This product detail can be read in the transaction history page",
        "jp-JP": "",
      },
      SA_TERMS_04_TXT: {
        "id-ID": "",
        "en-US":
          "Do you agree to continue the request for Salary Advance regular top up?",
        "jp-JP": "",
      },
      SA_TERMS_TITLE_TXT: {
        "id-ID": "",
        "en-US": "Terms and Conditions Agreement",
        "jp-JP": "",
      },
      SA_REGULAR_CHECK_TERMS_TXT: {
        "id-ID": "",
        "en-US":
          "I agree to allow SalAd system to regularly request Salary Advance on my behalf",
        "jp-JP": "",
      },
      SA_REGULAR_YES_TXT: {
        "id-ID": "",
        "en-US": "Yes",
        "jp-JP": "",
      },
      SA_REGULAR_NO_TXT: {
        "id-ID": "",
        "en-US": "No",
        "jp-JP": "",
      },
      REG_TOPUP_SA_TXT: {
        "id-ID": "",
        "en-US": "Salary Advance",
        "jp-JP": "",
      },
      REG_TOPUP_INSURANCE_TXT: {
        "id-ID": "",
        "en-US": "Insurance",
        "jp-JP": "",
      },
      REG_TOPUP_INVESTMENT_TXT: {
        "id-ID": "",
        "en-US": "Investment",
        "jp-JP": "",
      },
      REG_TOPUP_BILL_TXT: {
        "id-ID": "",
        "en-US": "Bill",
        "jp-JP": "",
      },
      REG_TOPUP_TOPUP_TXT: {
        "id-ID": "",
        "en-US": "Top Up",
        "jp-JP": "",
      },
      VERSION_TXT: {
        "id-ID": "",
        "en-US": "App Version 1.0.6",
        "jp-JP": "",
      },
      ADD_ACCOUNT_SUCCESS_TXT: {
        "id-ID": "",
        "en-US": "Account added",
        "jp-JP": "",
      },
      HOME_NB_1: {
        "id-ID": "Beranda",
        "en-US": "Home",
        "jp-JP": "ホームページ",
      },
      HOME_NB_2: {
        "id-ID": "Layanan",
        "en-US": "Feature",
        "jp-JP": "特徴",
      },
      HOME_NB_3: {
        "id-ID": "Tutorial",
        "en-US": "Tutorials",
        "jp-JP": "チュートリアル",
      },
      HOME_NB_4: {
        "id-ID": "Kontak",
        "en-US": "Contact",
        "jp-JP": "接触",
      },
      HOME_MT_1: {
        "id-ID": "Solusi Kasbon Karyawan Modern",
        "en-US": "Modern Employee Cash Advance Solution",
        "jp-JP": "現代的な従業員前払いソリューション",
      },
      HOME_MT_1_5: {
        "id-ID": "Cepat, Aman, dan Terintegrasi",
        "en-US": "Fast, Secure, and Integrated",
        "jp-JP": "迅速、安全、そして統合",
      },
      HOME_MT_2: {
        "id-ID":
          "Kelola pengajuan kasbon karyawan secara lebih efisien, transparan, dan terkontrol tanpa mengganggu arus kas perusahaan. Dengan Aplikasi Kasbon Karyawan dari Sal-ad, seluruh proses—mulai dari pengajuan, persetujuan, hingga pencatatan—dapat dilakukan secara digital melalui satu platform terintegrasi.",
        "en-US":
          "Manage employee cash advance requests more efficiently, transparently, and in a controlled manner without disrupting your company’s cash flow. With the Employee Cash Advance Application from Sal-ad, the entire process—from submission, approval, to recording—can be done digitally through one integrated platform.",
        "jp-JP":
          "従業員の前払い申請を、より効率的で透明性が高く、かつコントロールされた形で管理し、企業のキャッシュフローを妨げません。Sal-ad 従業員前払いアプリを使えば、申請から承認、記録まで、すべてのプロセスを1つの統合プラットフォーム上でデジタル化できます。",
      },
      HOME_GET_STARTED: {
        "id-ID": "Memulai",
        "en-US": "Get Started",
        "jp-JP": "始める",
      },
      HOME_LEARN_MORE: {
        "id-ID": "Pelajari Lebih Lanjut",
        "en-US": "Learn More",
        "jp-JP": "もっと詳しく知る",
      },
      HOME_REGISTERED_USERS: {
        "id-ID": "",
        "en-US": "Registered Users",
        "jp-JP": "",
      },
      HOME_ACTIVE_USERS: {
        "id-ID": "",
        "en-US": "Active Users",
        "jp-JP": "",
      },
      HOME_NUMBER_OF: {
        "id-ID": "",
        "en-US": "Number of total drawdowns",
        "jp-JP": "",
      },
      HOME_VALUE_OF: {
        "id-ID": "",
        "en-US": "Value of monthly loans",
        "jp-JP": "",
      },
      HOME_AVERAGE_LOAN: {
        "id-ID": "",
        "en-US": "Average loan duration",
        "jp-JP": "",
      },
      HOME_US4MN: {
        "id-ID": "",
        "en-US": "US$ 4 Mn",
        "jp-JP": "",
      },
      HOME_15_DAYS: {
        "id-ID": "15 Hari",
        "en-US": "15 Days",
        "jp-JP": "",
      },
      HOME_WHY_COMPANIES: {
        "id-ID": "Mengapa Perusahaan Membutuhkan Aplikasi Kasbon Digital",
        "en-US": "Why Companies Need a Digital Cash Advance Application",
        "jp-JP": "企業がデジタル前払いアプリを必要とする理由",
      },
      HOME_MANUAL_CASH: {
        "id-ID":
          "Pengelolaan kasbon secara manual sering kali memakan banyak waktu, rawan kesalahan, dan sulit diawasi. Proses yang rumit dapat menghambat kinerja karyawan dan mengganggu arus kas perusahaan.",
        "en-US":
          "Manual cash advance management often takes too much time, is prone to errors, and is difficult to monitor. Complicated procedures can hinder employee performance and disrupt the company’s cash flow.",
        "jp-JP":
          "前払いを手作業で管理すると、多くの時間がかかり、ミスが発生しやすく、監視も困難です。複雑な手続きは従業員のパフォーマンスを妨げ、企業のキャッシュフローに悪影響を与える可能性があります。",
      },
      HOME_WITH_CLOUDE: {
        "id-ID": "Dengan aplikasi kasbon berbasis cloud, perusahaan dapat:",
        "en-US": "With a cloud-based cash advance application, companies can:",
        "jp-JP":
          "クラウドベースの前払いアプリを導入することで、企業は次のことが可能になります：",
      },
      HOME_ACCELERATE_THE_SUBMISSION: {
        "id-ID":
          "Mempercepat proses pengajuan dan persetujuan tanpa formulir kertas atau pertemuan tatap muka.",
        "en-US":
          "Accelerate the submission and approval process without paper forms or face-to-face meetings.",
        "jp-JP": "紙の書類や対面の会議なしで、申請・承認プロセスを迅速化。",
      },
      HOME_MONITOR_THE_USE: {
        "id-ID":
          "Memantau penggunaan kasbon secara real-time dan mencegah pengeluaran yang tidak sesuai.",
        "en-US":
          "Monitor the use of cash advances in real time and prevent improper expenses.",
        "jp-JP": "リアルタイム監視で、前払い資金の不適切な使用を防止。",
      },
      HOME_OPTIMIZE_CASH_FLOW: {
        "id-ID":
          "Mengoptimalkan arus kas dengan pencatatan yang rapi dan akurat.",
        "en-US":
          "Optimize cash flow with organized and accurate recordkeeping.",
        "jp-JP": "正確で整理された記録管理により、キャッシュフローを最適化。",
      },
      HOME_INCREASE_TRANSPARENCY_BETWEEN: {
        "id-ID": "Meningkatkan transparansi antara karyawan dan manajemen.",
        "en-US": "Increase transparency between employees and management.",
        "jp-JP": "従業員と経営陣の間の透明性を向上。",
      },
      HOME_KEY_FEATURES_OF_SALAD: {
        "id-ID": "Fitur Utama Aplikasi Kasbon Sal-ad Pengajuan Kasbon Online",
        "en-US":
          "Key Features of Sal-ad Cash Advance Application Online Cash Advance Submission",
        "jp-JP": "Sal-ad 前払いアプリの主な機能 オンライン前払い申請",
      },
      HOME_EMPLOYEES_CAN_REQUEST: {
        "id-ID":
          "Karyawan dapat mengajukan kasbon kapan saja dan di mana saja melalui aplikasi desktop maupun mobile. Lampirkan bukti dan dokumen pendukung langsung di sistem.",
        "en-US":
          "Employees can request cash advances anytime and anywhere via desktop or mobile apps. Attach proof and supporting documents directly in the system.",
        "jp-JP":
          "従業員はデスクトップまたはモバイルアプリから、いつでもどこでも前払いを申請可能。証拠やサポート書類をシステムに直接添付。",
      },
      HOME_FAST_APPROVAL: {
        "id-ID": "Proses Persetujuan Cepat",
        "en-US": "Fast Approval Process",
        "jp-JP": "迅速な承認プロセス",
      },
      HOME_SETUP_APPROVAL: {
        "id-ID":
          "Atur alur persetujuan sesuai struktur organisasi. Manajer dapat menyetujui atau menolak pengajuan hanya dengan satu klik.",
        "en-US":
          "Set up approval workflows according to the organizational structure. Managers can approve or reject requests with just one click.",
        "jp-JP":
          "組織構造に沿った承認フローを設定可能。マネージャーはワンクリックで申請を承認または却下可能。",
      },
      HOME_AUTOMATIC_RECORDING: {
        "id-ID": "Pencatatan Otomatis",
        "en-US": "Automatic Recording",
        "jp-JP": "自動記録",
      },
      HOME_ALL_CASH_ADVANCE: {
        "id-ID":
          "Semua transaksi kasbon otomatis tercatat di sistem. Terintegrasi langsung dengan laporan keuangan perusahaan.",
        "en-US":
          "All cash advance transactions are automatically recorded in the system. Direct integration with the company’s financial reports.",
        "jp-JP":
          "すべての前払い取引はシステムに自動記録。企業の財務報告と直接連携。",
      },
      HOME_REAL_TIME_MONITORING: {
        "id-ID": "Pemantauan Real-Time",
        "en-US": "Real-Time Monitoring",
        "jp-JP": "リアルタイム監視",
      },
      HOME_VIEW_SUBMISSION: {
        "id-ID":
          "Lihat status pengajuan, persetujuan, dan pencairan dana secara instan. Data tersimpan aman di cloud dengan sistem enkripsi.",
        "en-US":
          "View submission, approval, and disbursement statuses instantly. Data is securely stored in the cloud with encryption systems.",
        "jp-JP":
          "申請、承認、資金支払いの状況を即時に確認。データはクラウドに安全に保存され、暗号化システムで保護。",
      },
      HOME_PAYROLL_INTEGRATION: {
        "id-ID": "Integrasi Payroll",
        "en-US": "Payroll Integration",
        "jp-JP": "給与計算との統合",
      },
      HOME_CASH_ADVANCE_DEDUCTIONS: {
        "id-ID":
          "Pemotongan kasbon dapat dilakukan otomatis melalui sistem penggajian. Mengurangi risiko keterlambatan pengembalian dana.",
        "en-US":
          "Cash advance deductions can be processed automatically through the payroll system. Reduces the risk of late repayments.",
        "jp-JP":
          "前払いの返済は給与システムを通じて自動的に控除可能。返済遅延のリスクを軽減。",
      },
      HOME_BENEFITS_FOR_COMPANY: {
        "id-ID": "Manfaat untuk Perusahaan",
        "en-US": "Benefits for Companies",
        "jp-JP": "企業にとってのメリット",
      },
      HOME_ADMINISTRATIVE_EFFICIENCY: {
        "id-ID": "Efisiensi Administrasi",
        "en-US": "Administrative Efficiency",
        "jp-JP": "事務効率化",
      },
      HOME_REDUCE_MANUAL_WORK: {
        "id-ID":
          "Mengurangi pekerjaan manual dan meminimalkan kesalahan input.",
        "en-US": "Reduce manual work and minimize input errors.",
        "jp-JP": "手作業を削減し、入力ミスを最小限に。",
      },
      HOME_FINANCIAL_TRANSPARENCY: {
        "id-ID": "Transparansi Keuangan",
        "en-US": "Financial Transparency",
        "jp-JP": "財務の透明性",
      },
      HOME_ALL_PARTIES_CAN: {
        "id-ID":
          "Semua pihak dapat memantau status dan riwayat kasbon secara terbuka.",
        "en-US":
          "All parties can monitor cash advance statuses and histories openly.",
        "jp-JP": "全員が前払いの状況と履歴をオープンに確認可能。",
      },
      HOME_EMPLOYEE_SATISFACTION: {
        "id-ID": "Kepuasan Karyawan",
        "en-US": "Employee Satisfaction",
        "jp-JP": "従業員満足度向上",
      },
      HOME_FAST_AND_CLEAR: {
        "id-ID": "Proses yang cepat dan jelas meningkatkan produktivitas.",
        "en-US": "Fast and clear processes improve productivity.",
        "jp-JP": "迅速で明確なプロセスが生産性を向上。",
      },
      HOME_BETTER_BUDGET_CONTROL: {
        "id-ID": "Kontrol Anggaran Lebih Baik",
        "en-US": "Better Budget Control",
        "jp-JP": "予算管理の向上",
      },
      HOME_ENSURE_FUNDS_ARE_USED: {
        "id-ID": "Memastikan dana digunakan sesuai kebutuhan bisnis.",
        "en-US": "Ensure funds are used according to business needs.",
        "jp-JP": "資金がビジネスニーズに沿って使用されることを保証。",
      },
      HOME_SALAD_DIGITAL_CASH: {
        "id-ID": "Alur Proses Kasbon Digital Sal-ad Pengajuan",
        "en-US": "Sal-ad Digital Cash Advance Workflow Submission",
        "jp-JP": "Sal-ad デジタル前払いプロセスの流れ申請",
      },
      HOME_EMPLOYEE_FILL_OUT_CASH: {
        "id-ID":
          "Karyawan mengisi formulir kasbon melalui aplikasi dan melampirkan dokumen pendukung.",
        "en-US":
          "Employees fill out the cash advance form via the app and attach documents.",
        "jp-JP":
          "従業員がアプリから前払い申請フォームを記入し、必要書類を添付。",
      },
      HOME_APPROVAL: {
        "id-ID": "Persetujuan",
        "en-US": "Approval",
        "jp-JP": "承認",
      },
      HOME_SUPERVISORS_RECEIVE: {
        "id-ID": "Atasan menerima notifikasi dan melakukan verifikasi.",
        "en-US": "Supervisors receive notifications and verify requests.",
        "jp-JP": "上司が通知を受け、申請を確認。",
      },
      HOME_DISBURSEMENT: {
        "id-ID": "Pencairan Dana",
        "en-US": "Disbursement",
        "jp-JP": "資金支払い",
      },
      HOME_CASH_ADVANCE_FUNDS_ARE: {
        "id-ID": "Dana kasbon ditransfer sesuai kebijakan perusahaan.",
        "en-US":
          "Cash advance funds are transferred according to company policy.",
        "jp-JP": "会社の規定に従って前払い資金を振込。",
      },
      HOME_RECORDING_AND_DEDUCATION: {
        "id-ID": "Pencatatan & Pemotongan",
        "en-US": "Recording & Deduction",
        "jp-JP": "記録＆控除",
      },
      HOME_TRANSACTIONS_ARE_AUTO: {
        "id-ID": "Transaksi otomatis tercatat dan dipotong saat payroll.",
        "en-US":
          "Transactions are automatically recorded and deducted during payroll.",
        "jp-JP": "取引は自動記録され、給与支払い時に控除。",
      },
      HOME_WHY_CHOOSE_SALAD: {
        "id-ID": "Mengapa Memilih Sal-ad?",
        "en-US": "Why Choose Sal-ad?",
        "jp-JP": "Sal-ad を選ぶ理由",
      },
      HOME_EXPERIENCED_IN_HRIS: {
        "id-ID":
          "Berpengalaman dalam solusi HRIS dan manajemen SDM berbasis teknologi.",
        "en-US":
          "Experienced in HRIS and technology-based HR management solutions.",
        "jp-JP":
          "HRISやテクノロジーを活用した人事管理ソリューションの豊富な経験。",
      },
      HOME_DATA_SECURITY_GUARANTEED: {
        "id-ID":
          "Keamanan Data Terjamin dengan standar setara industri keuangan.",
        "en-US":
          "Data Security Guaranteed with financial-industry-level standards.",
        "jp-JP": "金融業界レベルのデータセキュリティで安心。",
      },
      HOME_FULL_SUPPORT_FROM: {
        "id-ID":
          "Dukungan penuh dari tim Customer Success yang siap membantu kapan saja.",
        "en-US":
          "Full support from a dedicated Customer Success team ready to assist anytime.",
        "jp-JP": "専任のカスタマーサクセスチームがいつでもサポート。",
      },
      HOME_INTEGRATED_WITH_HR: {
        "id-ID":
          "Terintegrasi dengan sistem HR, payroll, dan keuangan perusahaan.",
        "en-US": "Integrated with HR, payroll, and company financial systems.",
        "jp-JP": "人事、給与計算、財務システムとの統合が可能。",
      },
      HOME_SEND_US_EMAIL: {
        "id-ID": "Kirim Email Ke Kami",
        "en-US": "Send Us Email",
        "jp-JP": "メールを送信",
      },
      HOME_CAPTCHA: {
        "id-ID": "Captcha",
        "en-US": "Captcha",
        "jp-JP": "キャプチャ",
      },
      HOME_ANSWER: {
        "id-ID": "Jawaban",
        "en-US": "Answer",
        "jp-JP": "答え",
      },
      HOME_IMPROVE_EFFICIENCY_AND_TRANSPARENCY: {
        "id-ID":
          "Tingkatkan efisiensi dan transparansi pengelolaan kasbon di perusahaan Anda. Rasakan pengalaman terbaik dalam manajemen kasbon karyawan bersama Sal-ad.",
        "en-US":
          "Improve efficiency and transparency in your company’s cash advance management. Experience the best in employee cash advance management with Sal-ad",
        "jp-JP":
          "企業の前払い管理の効率と透明性を向上させましょう。Sal-adと共に、従業員前払い管理の最良体験を手に入れてください。",
      },
      HOME_CONTACT_US_FOR_FREE: {
        "id-ID":
          "Hubungi kami untuk konsultasi gratis dan temukan bagaimana Sal-ad dapat membantu mengoptimalkan operasional bisnis Anda.",
        "en-US":
          "Contact us for a free consultation and discover how Sal-ad can help optimize your business operations.",
        "jp-JP":
          "無料相談はこちら – Sal-adがどのように貴社の業務最適化を支援できるかをご提案します。",
      },
      HOME_START_USING: {
        "id-ID": "Mulai Gunakan Sekarang",
        "en-US": "Start Using It Now",
        "jp-JP": "今すぐ導入",
      },
      HOME_VAULT_PROTECTION: {
        "id-ID": "",
        "en-US": "Vault protection",
        "jp-JP": "",
      },
      HOME_CALCULATE_PRECISE: {
        "id-ID": "",
        "en-US":
          "Calculate precise AI credit score based on historical data on between user’s attribution, market environment and bankruptcy probability. Block Chain technology is applied for fraud detection and prevention.",
        "jp-JP": "",
      },
      HOME_AI_INSURANCE: {
        "id-ID": "",
        "en-US": "AI Insurance",
        "jp-JP": "",
      },
      HOME_CALCULATING_PRECISE: {
        "id-ID": "",
        "en-US":
          "Calculating precise AI option premium based on historical data on between user’s attribution, market environment and life event probability, Block Chain technology is applied for fraud detection and prevention.",
        "jp-JP": "",
      },
      HOME_TARGETED_SEGMENT: {
        "id-ID": "",
        "en-US": "Targeted Segment Advertisement",
        "jp-JP": "",
      },
      HOME_PREDICT_INFLUENTIAL: {
        "id-ID": "",
        "en-US":
          "Predict influential segments and provide them precise customized and personalized ads.",
        "jp-JP": "",
      },
      HOME_STRATEGIC: {
        "id-ID": "",
        "en-US": "Strategic HR Consulting",
        "jp-JP": "",
      },
      HOME_ENHANCE: {
        "id-ID": "",
        "en-US":
          "Enhance retention rate by hiring people with higher loyalty and eliminate ones with less loyalty, predict segment of candidates that match or mismatch to company’s job requirement as example introduction of talented Asian candidates to Japanese companies vice versa.",
        "jp-JP": "",
      },
      HOME_GET_STARTED_IN: {
        "id-ID": "Mulai dalam hitungan menit",
        "en-US": "Get started in minutes",
        "jp-JP": "数分で開始できます",
      },
      HOME_EASY_WAY: {
        "id-ID": "Cara mudah menggunakan aplikasi salad",
        "en-US": "Easy way to use salad app",
        "jp-JP": "サラダアプリの簡単な使い方",
      },
      HOME_SIGN_IN: {
        "id-ID": "Masuk",
        "en-US": "Sign In",
        "jp-JP": "サインイン",
      },
      HOME_OPEN_BEEVER: {
        "id-ID":
          "Buka situs web salad di ponsel atau desktop, dan Masuk dengan akun Anda",
        "en-US":
          "Open salad website on mobile or desktop, and Sign-in with your account",
        "jp-JP":
          "モバイルまたはデスクトップでサラダのウェブサイトを開き、アカウントでサインインします",
      },
      HOME_REQUEST_AMOUNT: {
        "id-ID": "Jumlah Permintaan",
        "en-US": "Request Amount",
        "jp-JP": "請求金額",
      },
      HOME_SELECT_YOUR: {
        "id-ID":
          "Pilih jumlah permintaan Anda lalu pilih akun penerima Anda dan ketuk tombol permintaan",
        "en-US":
          "Select your request amount then select your receiving account and tap request button",
        "jp-JP":
          "リクエスト金額を選択し、受取口座を選択してリクエストボタンをタップします。",
      },
      HOME_CONFIRMATION: {
        "id-ID": "Konfirmasi",
        "en-US": "Confirmation",
        "jp-JP": "確認",
      },
      HOME_CONFIRM_YOUR_REQUESTED: {
        "id-ID": "Konfirmasikan jumlah yang Anda minta dan kirimkan",
        "en-US": "Confirm your requested amount and submit",
        "jp-JP": "ご希望金額を確認して送信してください",
      },
      HOME_DONE: {
        "id-ID": "Selesai",
        "en-US": "Done",
        "jp-JP": "終わり",
      },
      HOME_CONGRATULATIONS: {
        "id-ID": "Selamat, permintaan Anda telah berhasil dikirimkan",
        "en-US":
          "Congratulations, your request has been successfully submitted",
        "jp-JP": "おめでとうございます。リクエストは正常に送信されました。",
      },
      HOME_PRODUCT: {
        "id-ID": "Produk",
        "en-US": "Product",
        "jp-JP": "製品",
      },
      HOME_DOCUMENTATIONS: {
        "id-ID": "Dokumentasi",
        "en-US": "Documentations",
        "jp-JP": "ドキュメント",
      },
      HOME_INTEGRATIONS: {
        "id-ID": "Integrasi",
        "en-US": "Integrations",
        "jp-JP": "統合",
      },
      HOME_PRICING: {
        "id-ID": "Harga",
        "en-US": "Pricing",
        "jp-JP": "価格",
      },
      HOME_API: {
        "id-ID": "API",
        "en-US": "API",
        "jp-JP": "API",
      },
      HOME_COMPANY: {
        "id-ID": "Perusahaan",
        "en-US": "Company",
        "jp-JP": "会社",
      },
      HOME_ABOUT_US: {
        "id-ID": "Tentang Kami",
        "en-US": "About Us",
        "jp-JP": "私たちについて",
      },
      HOME_MEET_OUR_TEAM: {
        "id-ID": "Temui tim kami",
        "en-US": "Meet our team",
        "jp-JP": "私たちのチームを紹介します",
      },
      HOME_CAREERS: {
        "id-ID": "Karier",
        "en-US": "Careers",
        "jp-JP": "キャリア",
      },
      HOME_SUPPORT: {
        "id-ID": "Mendukung",
        "en-US": "Support",
        "jp-JP": "サポート",
      },
      HOME_KNOWLEDGE: {
        "id-ID": "Basis pengetahuan",
        "en-US": "Knowledge base",
        "jp-JP": "ナレッジベース",
      },
      HOME_TUTORIALS: {
        "id-ID": "Tutorial",
        "en-US": "Tutorials",
        "jp-JP": "チュートリアル",
      },
      HOME_ACCESS_PARTNERS: {
        "id-ID": "Mitra Akses",
        "en-US": "Access Partner",
        "jp-JP": "アクセスパートナー",
      },
      HOME_DOCUMENTS: {
        "id-ID": "Dokumen",
        "en-US": "Documents",
        "jp-JP": "文書",
      },
      HOME_GUIDELINES: {
        "id-ID": "Pedoman",
        "en-US": "Guidelines",
        "jp-JP": "ガイドライン",
      },
      HOME_CONTACT_US: {
        "id-ID": "Hubungi Kami",
        "en-US": "Contact Us",
        "jp-JP": "お問い合わせ",
      },
      HOME_EMAIL_CONTACT_US: {
        "id-ID": "cs@sal-ad.net",
        "en-US": "cs@sal-ad.net",
        "jp-JP": "cs@sal-ad.net",
      },
      HOME_STAYUPTODATE: {
        "id-ID": "Tetap Terkini",
        "en-US": "Stay Up to date",
        "jp-JP": "最新情報を入手",
      },
      HOME_SUBSCRIBE: {
        "id-ID": "Berlanggananlah untuk membaca buletin kami setiap minggu.",
        "en-US": "Subscribe to every weekly read our newsletter.",
        "jp-JP": "毎週のニュースレターを購読してください。",
      },
      HOME_ENTER_EMAIL: {
        "id-ID": "Masukkan Email",
        "en-US": "Enter Email",
        "jp-JP": "メールアドレスを入力",
      },
      DB_PLEASE_ADD: {
        "id-ID": "",
        "en-US": "Please activate your account",
        "jp-JP": "",
      },
      DB_BEFORE_YOU: {
        "id-ID": "",
        "en-US": "or add new account ...",
        "jp-JP": "",
      },
      DB_BANK: {
        "id-ID": "",
        "en-US": "Bank",
        "jp-JP": "",
      },
      DB_E_MONEY: {
        "id-ID": "",
        "en-US": "e-Money",
        "jp-JP": "",
      },
      DB_NO_TRANSACTION: {
        "id-ID": "",
        "en-US": "No transaction found",
        "jp-JP": "",
      },
      DB_SEE_MORE: {
        "id-ID": "",
        "en-US": "See More",
        "jp-JP": "",
      },
      KEY: {
        "id-ID": "",
        "en-US": "EN",
        "jp-JP": "",
      },
      ADDRESS_1: {
        "id-ID": "Jl. Sultan Hasanuddin Dalam Blok M",
        "en-US": "Jl. Sultan Hasanuddin Dalam Blok M",
        "jp-JP": "Jl. Sultan Hasanuddin Dalam Blok M",
      },
      ADDRESS_2: {
        "id-ID": "Melawai, Kecamatan Kebayoran Baru, Kota Jakarta Selatan",
        "en-US": "Melawai, Kebayoran Baru District, South Jakarta City",
        "jp-JP": "Melawai, Kebayoran Baru 区, 南ジャカルタ市",
      },
      ADDRESS_3: {
        "id-ID": "Daerah Khusus Ibukota Jakarta 12160",
        "en-US": "Special Capital Region of Jakarta 12160",
        "jp-JP": "ジャカルタ特別州 12160",
      },
      // --- HEADER ---
      PRIVACY_POLICY_TITLE: {
        "id-ID": "Kebijakan Privasi",
        "en-US": "Privacy Policy",
        "jp-JP": "プライバシーポリシー",
      },
      LAST_UPDATED: {
        "id-ID": "Terakhir diperbarui:",
        "en-US": "Last updated:",
        "jp-JP": "最終更新日：",
      },
      PRIVACY_POLICY_INTRO: {
        "id-ID":
          "PT.Tugboat Trading Indonesia (“Sal Ad”, “kami”) menghormati privasi Anda. Halaman ini menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, melindungi, dan membagikan data pribadi saat Anda menggunakan aplikasi maupun website Sal Ad.",
        "en-US":
          "PT.Tugboat Trading Indonesia (“Sal Ad”, “we”) respects your privacy. This page explains how we collect, use, store, protect, and share personal data when you use the Sal Ad application or website.",
        "jp-JP":
          "PT.Tugboat Trading Indonesia（「Sal Ad」、「当社」）は、お客様のプライバシーを尊重します。本ページでは、Sal Ad アプリケーションやウェブサイトをご利用の際に、当社がどのように個人データを収集、使用、保存、保護、共有するかを説明します。",
      },

      // --- SECTION 1 ---
      POLICY_SECTION_1_TITLE: {
        "id-ID": "1. Informasi yang Kami Kumpulkan",
        "en-US": "1. Information We Collect",
        "jp-JP": "1. 当社が収集する情報",
      },
      POLICY_SECTION_1_ITEM_1: {
        "id-ID":
          "Data Identitas: nama, email, nomor telepon, jabatan, dan informasi identifikasi lain yang relevan.",
        "en-US":
          "Identity Data: name, email, phone number, position, and other relevant identification information.",
        "jp-JP":
          "識別データ：氏名、メール、電話番号、役職、その他の関連識別情報。",
      },
      POLICY_SECTION_1_ITEM_2: {
        "id-ID":
          "Data Karyawan & Payroll: status kepegawaian, gaji, departemen, nomor rekening (untuk integrasi payroll).",
        "en-US":
          "Employee & Payroll Data: employment status, salary, department, bank account (for payroll integration).",
        "jp-JP":
          "従業員・給与データ：雇用状況、給与、部署、銀行口座（給与統合用）。",
      },
      POLICY_SECTION_1_ITEM_3: {
        "id-ID":
          "Data Transaksi: riwayat pengajuan kasbon, jumlah, tanggal, status persetujuan, pencairan, dan pengembalian.",
        "en-US":
          "Transaction Data: loan request history, amount, date, approval status, disbursement, and repayment.",
        "jp-JP": "取引データ：前借申請履歴、金額、日付、承認状況、送金、返済。",
      },
      POLICY_SECTION_1_ITEM_4: {
        "id-ID":
          "Dokumen Pendukung: bukti pengajuan, slip gaji, atau dokumen lain yang Anda unggah.",
        "en-US":
          "Supporting Documents: application proof, payslips, or other uploaded documents.",
        "jp-JP": "補助書類：申請証明、給与明細、その他アップロードされた書類。",
      },
      POLICY_SECTION_1_ITEM_5: {
        "id-ID":
          "Data Teknis: alamat IP, tipe perangkat, OS, browser, bahasa, lokasi perkiraan, cookie, dan log aktivitas.",
        "en-US":
          "Technical Data: IP address, device type, OS, browser, language, approximate location, cookies, and activity logs.",
        "jp-JP":
          "技術データ：IPアドレス、デバイスの種類、OS、ブラウザ、言語、推定位置、Cookie、アクティビティログ。",
      },

      // --- SECTION 2 ---
      POLICY_SECTION_2_TITLE: {
        "id-ID": "2. Cara Kami Menggunakan Informasi",
        "en-US": "2. How We Use Information",
        "jp-JP": "2. 当社が情報を利用する方法",
      },
      POLICY_SECTION_2_ITEM_1: {
        "id-ID": "Memproses pengajuan, persetujuan, dan pencairan kasbon.",
        "en-US": "Processing loan requests, approvals, and disbursements.",
        "jp-JP": "前借申請、承認、送金の処理。",
      },
      POLICY_SECTION_2_ITEM_2: {
        "id-ID": "Verifikasi identitas dan pencegahan penyalahgunaan.",
        "en-US": "Identity verification and prevention of misuse.",
        "jp-JP": "本人確認および不正利用の防止。",
      },
      POLICY_SECTION_2_ITEM_3: {
        "id-ID": "Penyediaan laporan transparan bagi karyawan dan perusahaan.",
        "en-US": "Providing transparent reports for employees and companies.",
        "jp-JP": "従業員および企業への透明性のあるレポートの提供。",
      },
      POLICY_SECTION_2_ITEM_4: {
        "id-ID":
          "Integrasi dengan sistem HR/payroll dan rekonsiliasi pembayaran.",
        "en-US":
          "Integration with HR/payroll systems and payment reconciliation.",
        "jp-JP": "人事・給与システムとの統合および支払いの照合。",
      },
      POLICY_SECTION_2_ITEM_5: {
        "id-ID": "Peningkatan keamanan, performa, dan pengalaman pengguna.",
        "en-US": "Improving security, performance, and user experience.",
        "jp-JP": "セキュリティ、パフォーマンス、ユーザー体験の向上。",
      },
      POLICY_SECTION_2_ITEM_6: {
        "id-ID":
          "Pengiriman notifikasi, pembaruan, dukungan, dan komunikasi terkait layanan.",
        "en-US":
          "Sending notifications, updates, support, and service-related communications.",
        "jp-JP": "通知、更新、サポート、サービス関連の連絡を送信。",
      },

      // --- SECTION 3 ---
      POLICY_SECTION_3_TITLE: {
        "id-ID": "3. Dasar Pemrosesan Data",
        "en-US": "3. Legal Basis for Processing",
        "jp-JP": "3. データ処理の法的根拠",
      },
      POLICY_SECTION_3_TEXT: {
        "id-ID":
          "Kami memproses data berdasarkan: (a) pelaksanaan kontrak dan hubungan kerja sama dengan perusahaan Anda; (b) kepentingan yang sah untuk mengoperasikan dan mengamankan layanan; (c) persetujuan Anda pada pemrosesan tertentu; serta (d) kepatuhan hukum sesuai peraturan yang berlaku.",
        "en-US":
          "We process data based on: (a) performance of contracts and cooperation with your company; (b) legitimate interests to operate and secure services; (c) your consent for certain processing; and (d) legal compliance under applicable regulations.",
        "jp-JP":
          "当社は次の根拠に基づいてデータを処理します：(a) 契約の履行および御社との協力関係、(b) サービスを運営・保護する正当な利益、(c) 特定の処理に対するお客様の同意、(d) 適用される法規制に基づく法令遵守。",
      },

      // --- SECTION 4 ---
      POLICY_SECTION_4_TITLE: {
        "id-ID": "4. Pembagian Informasi",
        "en-US": "4. Information Sharing",
        "jp-JP": "4. 情報の共有",
      },
      POLICY_SECTION_4_TEXT: {
        "id-ID":
          "Kami tidak menjual atau menyewakan data pribadi Anda. Data dapat dibagikan kepada:",
        "en-US":
          "We do not sell or rent your personal data. Data may be shared with:",
        "jp-JP":
          "当社はお客様の個人データを販売または貸与しません。データは次の場合に共有されることがあります：",
      },
      POLICY_SECTION_4_ITEM_1: {
        "id-ID":
          "Pihak internal (HR, manajemen, tim payroll) untuk keperluan operasional.",
        "en-US":
          "Internal parties (HR, management, payroll team) for operational purposes.",
        "jp-JP": "社内関係者（人事、経営陣、給与チーム）による業務目的。",
      },
      POLICY_SECTION_4_ITEM_2: {
        "id-ID":
          "Mitra & penyedia layanan (cloud, pembayaran, verifikasi, analitik) dengan perjanjian keamanan data.",
        "en-US":
          "Partners & service providers (cloud, payments, verification, analytics) bound by data security agreements.",
        "jp-JP":
          "パートナーおよびサービス提供者（クラウド、決済、認証、分析）とのデータセキュリティ契約。",
      },
      POLICY_SECTION_4_ITEM_3: {
        "id-ID": "Otoritas yang berwenang bila diwajibkan oleh hukum.",
        "en-US": "Authorities when required by law.",
        "jp-JP": "法令に基づく権限当局。",
      },

      // --- SECTION 5 ---
      POLICY_SECTION_5_TITLE: {
        "id-ID": "5. Penyimpanan & Keamanan Data",
        "en-US": "5. Data Storage & Security",
        "jp-JP": "5. データの保存とセキュリティ",
      },
      POLICY_SECTION_5_ITEM_1: {
        "id-ID": "Enkripsi saat transit dan saat tersimpan.",
        "en-US": "Encryption in transit and at rest.",
        "jp-JP": "転送中および保存中の暗号化。",
      },
      POLICY_SECTION_5_ITEM_2: {
        "id-ID": "Kontrol akses berbasis peran dan audit log.",
        "en-US": "Role-based access control and audit logs.",
        "jp-JP": "役割ベースのアクセス制御および監査ログ。",
      },
      POLICY_SECTION_5_ITEM_3: {
        "id-ID": "Praktik keamanan industri untuk mencegah akses tidak sah.",
        "en-US":
          "Industry-standard security practices to prevent unauthorized access.",
        "jp-JP": "不正アクセス防止のための業界標準セキュリティ対策。",
      },

      // --- SECTION 6 ---
      POLICY_SECTION_6_TITLE: {
        "id-ID": "6. Hak Pengguna",
        "en-US": "6. User Rights",
        "jp-JP": "6. ユーザーの権利",
      },
      POLICY_SECTION_6_ITEM_1: {
        "id-ID": "Mengakses dan memperoleh salinan data pribadi Anda.",
        "en-US": "Access and obtain a copy of your personal data.",
        "jp-JP": "ご自身の個人データへのアクセスとコピーの取得。",
      },
      POLICY_SECTION_6_ITEM_2: {
        "id-ID": "Memperbaiki data yang tidak akurat atau tidak lengkap.",
        "en-US": "Correct inaccurate or incomplete data.",
        "jp-JP": "不正確または不完全なデータの修正。",
      },
      POLICY_SECTION_6_ITEM_3: {
        "id-ID": "Meminta penghapusan data sesuai hukum.",
        "en-US": "Request deletion of data in accordance with the law.",
        "jp-JP": "法律に従ったデータ削除の要求。",
      },
      POLICY_SECTION_6_ITEM_4: {
        "id-ID": "Menarik persetujuan untuk pemrosesan tertentu.",
        "en-US": "Withdraw consent for certain processing.",
        "jp-JP": "特定の処理に対する同意の撤回。",
      },
      POLICY_SECTION_6_ITEM_5: {
        "id-ID": "Mengajukan pertanyaan atau keluhan terkait data.",
        "en-US": "Submit questions or complaints regarding data.",
        "jp-JP": "データに関する質問または苦情の提出。",
      },

      // --- SECTION 7 ---
      POLICY_SECTION_7_TITLE: {
        "id-ID": "7. Cookies & Teknologi Pelacakan",
        "en-US": "7. Cookies & Tracking Technologies",
        "jp-JP": "7. Cookieとトラッキング技術",
      },
      POLICY_SECTION_7_TEXT: {
        "id-ID":
          "Kami menggunakan cookies untuk menyimpan preferensi, menganalisis penggunaan, serta meningkatkan pengalaman layanan.",
        "en-US":
          "We use cookies to store preferences, analyze usage, and improve service experience.",
        "jp-JP":
          "当社は、Cookieを使用して設定を保存し、利用状況を分析し、サービス体験を向上させます。",
      },

      // --- SECTION 8 ---
      POLICY_SECTION_8_TITLE: {
        "id-ID": "8. Retensi Data",
        "en-US": "8. Data Retention",
        "jp-JP": "8. データ保持",
      },
      POLICY_SECTION_8_TEXT: {
        "id-ID":
          "Data disimpan selama diperlukan atau diwajibkan oleh hukum, lalu dihapus atau dianonimkan secara aman.",
        "en-US":
          "Data is retained as long as necessary or required by law, then securely deleted or anonymized.",
        "jp-JP":
          "データは必要な期間または法令で義務付けられた期間保持され、その後安全に削除または匿名化されます。",
      },

      // --- SECTION 9 ---
      POLICY_SECTION_9_TITLE: {
        "id-ID": "9. Privasi Anak",
        "en-US": "9. Children’s Privacy",
        "jp-JP": "9. 子供のプライバシー",
      },
      POLICY_SECTION_9_TEXT: {
        "id-ID":
          "Layanan Sal Ad tidak ditujukan bagi anak di bawah 18 tahun. Kami tidak secara sadar mengumpulkan data dari anak di bawah umur.",
        "en-US":
          "Sal Ad services are not intended for children under 18. We do not knowingly collect data from minors.",
        "jp-JP":
          "Sal Ad のサービスは18歳未満の子供を対象としていません。当社は未成年からデータを意図的に収集しません。",
      },

      // --- SECTION 10 ---
      POLICY_SECTION_10_TITLE: {
        "id-ID": "10. Transfer Data Lintas Wilayah",
        "en-US": "10. Cross-Border Data Transfers",
        "jp-JP": "10. 国境を越えたデータ移転",
      },
      POLICY_SECTION_10_TEXT: {
        "id-ID":
          "Jika diperlukan, data dapat diproses di luar Indonesia dengan perlindungan setara dan perjanjian pemrosesan.",
        "en-US":
          "If necessary, data may be processed outside Indonesia with equivalent protection and proper agreements.",
        "jp-JP":
          "必要に応じて、データはインドネシア国外で処理され、同等の保護と適切な契約が確保されます。",
      },

      // --- SECTION 11 ---
      POLICY_SECTION_11_TITLE: {
        "id-ID": "11. Perubahan Kebijakan Privasi",
        "en-US": "11. Changes to Privacy Policy",
        "jp-JP": "11. プライバシーポリシーの変更",
      },
      POLICY_SECTION_11_TEXT: {
        "id-ID":
          "Kebijakan ini dapat diperbarui dari waktu ke waktu. Perubahan signifikan akan diberitahukan. Dengan terus menggunakan layanan, Anda dianggap menyetujui versi terbaru.",
        "en-US":
          "This policy may be updated from time to time. Significant changes will be notified. By continuing to use the services, you agree to the latest version.",
        "jp-JP":
          "このポリシーは随時更新される場合があります。重大な変更は通知されます。サービスを継続利用することで、最新バージョンに同意したとみなされます。",
      },

      // --- TOC ---
      TOC_TITLE: {
        "id-ID": "Daftar Isi",
        "en-US": "Table of Contents",
        "jp-JP": "目次",
      },

      TOC_SECTION_1: {
        "id-ID": "Informasi yang Kami Kumpulkan",
        "en-US": "Information We Collect",
        "jp-JP": "当社が収集する情報",
      },
      TOC_SECTION_2: {
        "id-ID": "Cara Kami Menggunakan Informasi",
        "en-US": "How We Use Information",
        "jp-JP": "当社が情報を利用する方法",
      },
      TOC_SECTION_3: {
        "id-ID": "Dasar Pemrosesan Data",
        "en-US": "Legal Basis for Processing",
        "jp-JP": "データ処理の法的根拠",
      },
      TOC_SECTION_4: {
        "id-ID": "Pembagian Informasi",
        "en-US": "Information Sharing",
        "jp-JP": "情報の共有",
      },
      TOC_SECTION_5: {
        "id-ID": "Penyimpanan & Keamanan Data",
        "en-US": "Data Storage & Security",
        "jp-JP": "データの保存とセキュリティ",
      },
      TOC_SECTION_6: {
        "id-ID": "Hak Pengguna",
        "en-US": "User Rights",
        "jp-JP": "ユーザーの権利",
      },
      TOC_SECTION_7: {
        "id-ID": "Cookies & Teknologi Pelacakan",
        "en-US": "Cookies & Tracking Technologies",
        "jp-JP": "Cookieとトラッキング技術",
      },
      TOC_SECTION_8: {
        "id-ID": "Retensi Data",
        "en-US": "Data Retention",
        "jp-JP": "データ保持",
      },
      TOC_SECTION_9: {
        "id-ID": "Privasi Anak",
        "en-US": "Children’s Privacy",
        "jp-JP": "子供のプライバシー",
      },
      TOC_SECTION_10: {
        "id-ID": "Transfer Data Lintas Wilayah",
        "en-US": "Cross-Border Data Transfers",
        "jp-JP": "国境を越えたデータ移転",
      },
      TOC_SECTION_11: {
        "id-ID": "Perubahan Kebijakan Privasi",
        "en-US": "Changes to Privacy Policy",
        "jp-JP": "プライバシーポリシーの変更",
      },
    },
  },
  reducers: {
    setTranslations: (state, action) => {
      state.translations = action.payload;
    },
    setLanguage: (state, action) => {
      state.active = action.payload;
    },
  },
});

export const { setTranslations, setLanguage } = langaugeSlice.actions;

langaugeSlice.selector = {
  all: (state) => state[langaugeSlice.name],
  active: (state) => state[langaugeSlice.name].active,
  languages: (state) => state[langaugeSlice.name].languages,
};

export default langaugeSlice;
